export default {
  rewriteRoute: {
    path: '/treasurebox/invitedetail',
    name: 'treasureboxInvitedetail',
  },
}
